import ZoneFormController from './zones.form.controller';

export default {
    template: require('./zones.form.html'),
    controller: ZoneFormController
};
